<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-right`]" width="1em" height="1em" v-bind="$attrs"><path d="M6.64429 10.9771C6.82413 10.9696 7.03576 10.7787 7.45875 10.398L9.46265 8.5943C9.69136 8.38847 9.8061 8.28581 9.8484 8.16462C9.88549 8.05813 9.88547 7.94201 9.8484 7.83551C9.80615 7.71424 9.69147 7.61078 9.46265 7.40485L7.45875 5.60212C7.03576 5.22144 6.82413 5.03052 6.64429 5.02301C6.48816 5.01655 6.33766 5.08327 6.23804 5.20368C6.12335 5.34234 6.12379 5.62708 6.12379 6.19587V9.80329C6.12379 10.3718 6.12363 10.6566 6.23804 10.7955C6.33766 10.9159 6.48815 10.9836 6.64429 10.9771Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillRight',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
